import { useCallback } from "react";
import {
    FinancialDocumentExtended,
    SpreadsheetImporterStatus,
} from "@common/types/financialDocument";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { IMPORTER_TOAST_KEY } from "./ImporterToast.lib";
import { ImporterToast } from "./ImporterToast";

export function useNotifyUnfinishedImport(subject: string) {
    const toaster = useToaster();

    return useCallback(
        (financialDocuments: FinancialDocumentExtended[]) => {
            const hasUnfinishedImport = financialDocuments.some(
                (financialDocument) =>
                    financialDocument.spreadsheetImporterStatus !==
                    SpreadsheetImporterStatus.IMPORT_SUCCESS,
            );
            if (hasUnfinishedImport) {
                toaster.toast(
                    <ImporterToast subject={subject} />,
                    IMPORTER_TOAST_KEY,
                );
            }
        },
        [subject, toaster],
    );
}
